// TODO: remove trailing slash
export const authApiRoot = "/auth";
export const apiRoot = "/api";
export const machineApiRoot = "/api/machineApi";
export const twinsRoot = "/twins";
export const aiRoot = "/machineApi/ai";
export const pipelineRoot = "/pipelines";
export const signalsRoot = "/machineApi/signals";
export const documentsRoot = "/api";
// export const documentsRoot = '/api/documents'
